





























import Vue from 'vue';
import { mapActions } from 'vuex';

import { ZenFormGroup } from 'zenComponents';
import { BRow, BCol, BFormCheckbox, VBTooltip } from 'bootstrap-vue';

export default Vue.extend({
  name: 'AuditInfoSync',
  components: {
    ZenFormGroup,
    BRow,
    BCol,
    BFormCheckbox,
  },
  directives: {
    BTooltip: VBTooltip,
  },
  props: {
    syncExternalComments: {
      type: Boolean,
      required: true,
    },
    syncExternalAttachments: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      project: null,
      projectsIsLoaded: false,
      projectsLoadedError: undefined,
    };
  },
  methods: {
    ...mapActions('auditSetupWizard', ['setSyncExternalComments', 'setSyncExternalAttachments']),
  },
});
